import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgMaterialModule } from '../ng-material/ng-material.module';
import { SharedModule } from '../shared/shared.module';
import { MarketingModuleRoutingModule } from './marketing-routing.module';
import { MarketingComponent } from './components/marketing/marketing.component';
import { CreateEditCampaignComponent } from './components/create-edit-campaign/create-edit-campaign.component';
import { MarketingContactsComponent as MarketingContactsComponent } from './components/marketing-contacts/marketing-contacts.component';
import { MarketingNavigationComponent } from './components/marketing-navigation/marketing-navigation.component';



@NgModule({
  declarations: [
    CreateEditCampaignComponent,
    MarketingComponent,
    MarketingNavigationComponent,
    MarketingContactsComponent
  ],
  imports: [
    SharedModule,
    CommonModule,
    ReactiveFormsModule,
    // DragDropModule,
    MarketingModuleRoutingModule,
    NgxChartsModule,
    GoogleMapsModule,
    HttpClientModule,
    ClipboardModule,
    NgMaterialModule
  ]
})
export class MarketingModule { }
